import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FullPageErrorFallback } from '../../ErrorBoundary/Fallbacks/FullPageErrorFallback';
import { FallbackProps } from 'react-error-boundary';
import locale from './customReports-locale.json';
import { styles } from './CustomReportsFallback.styles';

type Props = {
  error: Error;
  resetErrorBoundary: FallbackProps['resetErrorBoundary'];
};

export function CustomReportsFallback({ error, resetErrorBoundary }: Props) {
  return (
    <Box sx={styles.container}>
      <Typography variant="h3" gutterBottom>
        {locale.fallback.title}
      </Typography>
      <Typography variant="body2" sx={styles.subtitleText}>
        {locale.fallback.subtitle}
      </Typography>

      <FullPageErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
    </Box>
  );
}
